<template>
  <v-card color="grey lighten-3" id="holdCard">
    <div id="pdf"></div>
    <v-card-title>
      <v-col cols="12" :md="4" :sm="12" class="">
        <h4 class="green--text">Politik<span class="pink--text">.sms</span></h4>
      </v-col>
      <v-spacer/>
      <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
      />
      <v-spacer/>
      <v-btn icon @click="exportPDF">
        <v-icon class="red--text">mdi-file</v-icon>
      </v-btn>
      <export-excel
          class="btn btn-default"
          :data="localtableData"
          :fields="excelHeaders"
          type="csv"
          :name="title +'.xls'">
        <v-btn icon>
          <v-icon class="green--text">mdi-file-excel</v-icon>
        </v-btn>
      </export-excel>

    </v-card-title>
    <div id="printSection" ref="content">
      <v-data-table
          :headers="dessertHeaders"
          :items="localtableData"
          item-key="name"
          class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-spacer/>
            <v-toolbar-title>
              <h5 class="green--text">{{ split2(title, ' ')[0] }}<span class="pink--text ml-2 ">{{
                  split2(title, ' ')[1]
                }}</span></h5>
            </v-toolbar-title>
            <v-spacer/>
          </v-toolbar>
        </template>
        <template v-slot:footer>
          <v-divider/>
          <div class="text-justify caption pa-1" style="font-size: 6px">
            Disclaimer: This is a system generated report
          </div>
          <v-divider/>
          <div class="text-start caption pa-1">
            <span class="green--text">Politik<span class="pink--text">.sms</span></span> - www.politik.co.ke &nbsp;
          </div>
        </template>
      </v-data-table>
    </div>
  </v-card>
</template>

<script>
import print from "print-js";

export default {
  name: "nestedTable",
  props: {
    tableData: {
      required: true
    },
    title: {
      required: true
    },
    bias: {
      required: false,
      default: 1,
    }
  },
  data() {
    return {
      expanded: [],
      localtableData: [],
      search: "",
      singleExpand: false,
      dessertHeaders: [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        {text: 'Votes', value: 'votes'},
        {text: 'Percentage', value: 'percent'},
      ],
    }
  },
  computed: {
    excelHeaders() {
      let df = {};
      for (let i = 0; i < this.dessertHeaders.length; i++) {
        // console.log(this.dessertHeaders[i]);
        if (this.dessertHeaders[i].value !== 'action') {
          if (this.dessertHeaders[i].value === 'phone') {
            df[this.dessertHeaders[i].text] = {
              field: this.dessertHeaders[i].value,
              callback: (value) => {
                return value.toString()
              }
            }
          } else {
            df[this.dessertHeaders[i].text] = this.dessertHeaders[i].value;
          }
        }
      }
      return df;
    }
  },
  methods: {
    editItem(item) {
      this.$emit('editItem', {
        item
      })
    },
    split2(str, delim) {
      var parts = str.split(delim);
      return [parts[0], parts.splice(1, parts.length).join(delim)];
    },
    revokeOrderD(item) {
      this.$emit('revokeOrderD', {
        item
      })
    },
    seeItem(item) {
      this.$emit('viewItem', {
        item
      })
    },
    freezeUnfreezeItem(item) {
      this.$emit('freezeUnfreeze', {
        item
      })
    },
    // viewItem(item) {
    //     this.$emit('viewItem', {
    //         item
    //     })
    // },
    logoutAttendant(item) {
      this.$emit('logoutAttendant', {
        item
      })
    },
    testPrint() {

      var divToPrint = this.$refs.content
      let newWin = window.open("");
      newWin.document.write(divToPrint.outerHTML);
      newWin.print();
      newWin.close();
    },
    printPDF: function () {
      const prtHtml = document.getElementById('printSection').innerHTML;

// Get all stylesheets HTML
      let stylesHtml = '';
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

// Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

      WinPrint.document.write(`<!DOCTYPE html>
                        <html>
                          <head>
                            ${stylesHtml}
                          </head>
                          <body>
                            ${prtHtml}
                          </body>
                        </html>`);

      // WinPrint.document.close();
      // WinPrint.focus();
      WinPrint.print();
      // WinPrint.close();
    },
    exportPDF() {
      print({
        printable: this.localtableData,
        header: this.title.toUpperCase(),
        headerStyle: "margin:0 auto; justify:center;text-align:center",
        properties: this.dessertHeaders.map(item => {
          return {
            field: item.value ? item.value : '----',
            displayName: item.text ? item.text : '-----'
          }
        }),
        type: 'json',
        css: "css/print.css",
        gridStyle: 'border: 1px solid green; margin-bottom: -1px;',
        gridHeaderStyle: 'color: green;  border: 2px solid #3971A5;text-align:left;',
        documentTitle: this.title + ".pdf"
      })
      // var title ="test";
      // var divContents = $("#printSection").html();
      // var $cssLink = $('link');
      // var printWindow = window.open('', '', 'height=' + window.outerHeight * 0.6 + ', width=' + window.outerWidth  * 0.6);
      // printWindow.document.write('<html><head><h2><b><title>' + title + '</title></b></h2>');
      // for(var i = 0; i<$cssLink.length; i++) {
      //     printWindow.document.write($cssLink[i].outerHTML);
      // }
      // printWindow.document.write('</head><body >');
      // printWindow.document.write(divContents);
      // printWindow.document.write('</body></html>');
      // printWindow.document.close();
      // printWindow.onload = function () {
      //     printWindow.focus();
      //     setTimeout( function () {
      //         printWindow.print();
      //         printWindow.close();
      //     }, 100);
      // }
      // var divElements = document.getElementById("printSection").innerHTML;
      //
      // var oldPage = document.body.innerHTML;
      //
      // document.body.innerHTML =
      //
      //     "<html><head><title></title></head><body>" +
      //     divElements + "</body>";
      // window.print();
      // document.body.innerHTML = oldPage;
      // const element = document.getElementById('printSection');
      // const opt = {
      //     margin: 0.25,
      //     filename: this.title.toUpperCase() + '.pdf',
      //     image: {type: 'jpeg', quality: 0.98},
      //     html2canvas: {scale: 2},
      //     jsPDF: {unit: 'mm', format: 'a4', orientation: 'landscape'}
      // };
      // // html2pdf(element, opt);
      // html2pdf().set(opt).from(element).save();
    },
    exportCSV() {
    },
    deleteItem(item) {
      const index = this.tableRowData.indexOf(item);
      this.$emit('deleteItem', {
        item
      })
    },
    rowClicked(e) {
      this.$emit('rowClicked', {
        e
      })
    },
  },
  mounted() {
    this.localtableData = this.tableData.map(item => {
      return {
        ...item,
        votes: (item.votes * this.bias).toFixed(0),
        'percent': ((item.votes / this.tableData.map(bill => bill.votes).reduce((acc, bill) => bill + acc)) * 100).toFixed(0) + '%'
      }
    })
  }
}
</script>

<style scoped>

</style>